import { useMemo } from 'react';
import { ProgressBar } from '../../Common';
import { useTranslation } from '../../../hooks/useTranslation';
import { DateTime } from 'luxon';
import { OrganizationMembersWithBranchDataDto } from '../../../commonTypes/acs';

interface IMemberTablePolicies {
    member: OrganizationMembersWithBranchDataDto;
    selectedOrganizationPolicyId: string;
    isDataReady: boolean;
}

export const MembersPoliciesProgress = ({ member, selectedOrganizationPolicyId, isDataReady }: IMemberTablePolicies) => {
    const { t } = useTranslation();

    const policyIndex = useMemo(() => {
        return member.policies.findIndex(policy => policy.organizationPolicyId === selectedOrganizationPolicyId);
    }, [member, selectedOrganizationPolicyId]);

    const policy = member.policies[policyIndex] || { amount: 0, carriedOverAmount: 0, initialAmount: 0, initialCarriedOverAmount: 0 };

    const today = DateTime.now();
    const carriedOverValidTo = DateTime.fromObject({ day: policy.carriedOverValidToDay, month: policy.carriedOverValidToMonth, year: today.year });

    const amount = carriedOverValidTo > today ? Number(policy.amount) + Number(policy.carriedOverAmount) : Number(policy.amount);

    const total = carriedOverValidTo > today ? Number(policy.initialAmount) + Number(policy.initialCarriedOverAmount) : Number(policy.initialAmount);

    const segments = [{ id: 'amount', value: policy.amount, color: '#4b99f5', tooltip: t('leaveRequest.annualDays') }];

    if (carriedOverValidTo > today)
        segments.push({ id: 'carriedOverAmount', value: policy.carriedOverAmount, color: '#7cd992', tooltip: t('leaveRequest.carriedOverDays') });

    return (
        <div className="organization-members__days">
            {isDataReady ? (
                <>
                    {policyIndex !== -1 ? (
                        <>
                            <p className="paragraph-3">
                                <span className="organization-members__days--amount">{amount}</span>/{total}
                                {t('leaveRequest.dayUnit')}
                            </p>
                            <ProgressBar segments={segments} total={total} />
                        </>
                    ) : (
                        <span>{t('members.noPolicyMessage')}</span>
                    )}
                </>
            ) : (
                <p className="paragraph-3">{t('common.loading')}...</p>
            )}
        </div>
    );
};
